export function createLogger() {}